import React from 'react';
import { useTranslation } from 'react-i18next';
import IconBoxStyle11 from '../../IconBox/IconBoxStyle11';
import Spacing from '../../Spacing';

export default function ContactInfoSection({ sectionTitle }) {
  const { t } = useTranslation();

  return (
    <div className="container">
      <h2 className="cs_fs_72 mb-0">{sectionTitle}</h2>
      <Spacing md="70" lg="50" />
      <div className="row g-4 g-xl-3 g-xxl-5">
        <div className="col-xl-4">
          <IconBoxStyle11
            title={t('contact.phoneTitle')}
            subTitle={t('contact.phoneNumber')}
            iconSrc="/images/contact/icon_1.svg"
          />
        </div>
        <div className="col-xl-4">
          <IconBoxStyle11
            title={t('contact.emailTitle')}
            subTitle={t('contact.emailAddress')}
            iconSrc="/images/contact/icon_2.svg"
          />
        </div>
        <div className="col-xl-4">
          <IconBoxStyle11
            title={t('contact.locationTitle')}
            subTitle={t('contact.address')}
            iconSrc="/images/contact/icon_3.svg"
          />
        </div>
      </div>
      <Spacing md="35" />
      {/* Start Google Map */}
      <div className="cs_map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2997.3177390963633!2d19.742737299999995!3d41.301950899999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13502ffd383168a1%3A0x943040c09957111f!2sINCoMED%20shpk!5e0!3m2!1sen!2s!4v1765116030963!5m2!1sen!2s"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title={t('contact.mapTitle')}
        />
      </div>
      {/* End Google Map */}
    </div>
  );
}
